import { env } from "../../../config/env";
import { apiClient } from "../../config";
import {
  GetArticlesResponse,
  GetArticleResponse,
} from "../../interface/articles.interface";

/**
 * ============================================
 * 📝 PUBLIC ARTICLES SERVICE
 * ============================================
 */

class ArticlesService {
  /**
   * 📄 GET ARTICLES
   */
  async getArticles(): Promise<GetArticlesResponse> {
    const response = await apiClient.get<GetArticlesResponse>(
      env.ARTICLES.PUBLIC.BASE
    );

    return response.data;
  }

  /**
   * 📄 GET ARTICLE BY ID
   */
  async getArticle(id: string): Promise<GetArticleResponse> {
    const response = await apiClient.get<GetArticleResponse>(
      env.ARTICLES.PUBLIC.ONE(id)
    );

    return response.data;
  }
}

export const publicArticlesService = new ArticlesService();